import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ResponseEvent;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { IconImageSolid } from '@instructure/ui-icons';
import { Text } from '@instructure/ui-text';
import { Img } from '@instructure/ui-img';
import { ToggleDetails } from '@instructure/ui-toggle-details';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
import { EventDetails } from '../resources/EventDetails';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
import { sessionValidationErrorsPropType, eventDataPropType } from '../../../reporting/components/resources/common/propTypes';
var imgRegex = /<img.*?src=['"](.+)['"]/g;
export var ResponseEvent = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ResponseEvent = /*#__PURE__*/function (_Component) {
  function ResponseEvent() {
    _classCallCheck(this, ResponseEvent);
    return _callSuper(this, ResponseEvent, arguments);
  }
  _inherits(ResponseEvent, _Component);
  return _createClass(ResponseEvent, [{
    key: "getReadableResponseText",
    value: function getReadableResponseText() {
      var responseValue = this.props.event.getIn(['eventData', 'userResponse', 'value']);
      if (responseValue != null && !['string', 'boolean', 'number'].includes(typeof responseValue)) {
        responseValue = responseValue.toJS();
      }
      if (responseValue != null) {
        return this.props.item.getInteractionType().getRenderedResponse(responseValue, this.props.item.get('interactionData').toJS());
      }
    }
  }, {
    key: "itemBody",
    get: function get() {
      return this.props.item.get('itemBody');
    }
  }, {
    key: "hasMedia",
    value: function hasMedia() {
      return this.itemBody.match(imgRegex);
    }
  }, {
    key: "renderTextSummary",
    value: function renderTextSummary() {
      var isBreach = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var strippedItemBody = extractTextFromHtml(this.itemBody);
      return jsx("span", null, this.hasMedia() && jsx(IconImageSolid, {
        css: this.props.styles.answerMediaIcon
      }), jsx(Text, {
        color: isBreach ? 'danger' : 'primary'
      }, t('Answered question {position}: {question}', {
        position: this.props.event.getIn(['eventData', 'position']),
        question: strippedItemBody
      })));
    }
  }, {
    key: "renderMedia",
    value: function renderMedia() {
      var _this = this;
      if (!this.hasMedia()) {
        return;
      }
      var mediaUrls = this.itemBody.match(imgRegex);
      return mediaUrls.map(function (mediaUrl) {
        var s3Url = mediaUrl.match(/src=['"](.+)['"]/)[1];
        return jsx("div", {
          css: _this.props.styles.mediaToggle,
          key: s3Url
        }, jsx(ToggleDetails, {
          summary: t('Included Media'),
          variant: "filled"
        }, jsx("div", {
          css: _this.props.styles.embeddedImage
        }, jsx(Img, {
          src: s3Url
        }))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        validationErrors = _this$props.validationErrors,
        currentEventData = _this$props.currentEventData;
      var responseText = this.getReadableResponseText();
      if (responseText) {
        // If this returns falsey, then we know to just display the stem
        return jsx(ToggleDetails, {
          summary: this.renderTextSummary(validationErrors.isBreach)
        }, this.renderMedia(), jsx(EventDetails, {
          currentEventData: currentEventData,
          validationErrors: validationErrors,
          answerValue: responseText
        }));
      } else {
        return jsx(Text, {
          size: "small"
        }, this.renderTextSummary(validationErrors.isBreach), jsx(EventDetails, {
          currentEventData: currentEventData,
          validationErrors: validationErrors
        }), this.renderMedia());
      }
    }
  }]);
}(Component), _defineProperty(_ResponseEvent, "displayName", 'ResponseEvent'), _defineProperty(_ResponseEvent, "componentId", "Quizzes".concat(_ResponseEvent.displayName)), _defineProperty(_ResponseEvent, "propTypes", {
  event: ImmutablePropTypes.record.isRequired,
  item: ImmutablePropTypes.record.isRequired,
  styles: PropTypes.object,
  validationErrors: sessionValidationErrorsPropType,
  currentEventData: eventDataPropType
}), _ResponseEvent)) || _class);
export default ResponseEvent;